<template>
    <section>
        <div class="container pb-5">
            <b-row>
                <b-col cols="12">
                    <h2>Uitleendienst Erfgoed</h2>
                    <p>
                    De Uitleendienst Erfgoed leent materiaal uit aan organisaties uit de cultureel-erfgoedsector om hen te ondersteunen bij het beheer van hun erfgoedcollectie.
                    Deze dienstverlening is gratis, maar je haalt het materiaal zelf af, draagt er goed zorg voor en brengt het tijdig terug. Zo kan iedereen ervan genieten.
                    FARO en de onderstaande partners stellen een basisaanbod ter beschikking in verschillende uitleenpunten verspreid over Vlaanderen.
                    </p>

                    <h2>Hoe materiaal aanvragen?</h2>
                    <p>
                    Via deze website dien je een aanvraag in en verklaar je je akkoord met de Algemene voorwaarden.
                    Na bevestiging door FARO is je reservering definitief.
                    Je ontvangt per e-mail een document waarmee je het materiaal kunt afhalen in het gekozen uitleenpunt.
                    Bijkomend advies over de aanpak van je project is altijd mogelijk. Richt je vraag aan <a href="mailto:uitleendienst@faro.be">uitleendienst@faro.be</a>.
                    </p>
                    <!-- <p>
                        <b><i>Kies een uitleenpunt om materiaal aan te vragen:</i></b>
                    </p>
                    <p>
                        Als je aanmeldt op de website is het mogelijk om specifieke producten van onderstaande uitleenpunten te bekijken.
                    </p> -->
                    <p>
                        Meld je aan (rechtsboven) en <b>kies</b> vervolgens een <b>uitleenpunt</b>, om specifieke producten te bekijken en te reserveren.
                    </p>
                </b-col>
            </b-row>
            <b-row v-for="(warehousesRow, index) in trioWarehousesCollection" :key="index">
                <b-col class="mt-8" md="4" sm="12" xs="12" v-for="warehouse in warehousesRow" :key="warehouse.WarehouseID">
                    <div class="card card-warehouse">
                    <div class="card-header ">
                        {{warehouse.WarehouseID}}
                    </div>
                    <div class="card-body">
                        <ul>
                            <li>
                                <strong>Magazijn:</strong>
                                <p v-html="warehouse.WarehouseID"></p>
                            </li>
                            <li>
                                <strong>Adres:</strong>
                                <p v-html="warehouse.CUST_Address"></p>
                            </li>
                            <li v-if="warehouse.CUST_OpeningHours">
                                <strong>Openingstijden:</strong>
                                <p v-html="warehouse.CUST_OpeningHours"></p>
                            </li>
                            <li>
                                <strong>Telefoon:</strong>
                                <p v-html="warehouse.CUST_PhoneNumber"></p>
                            <li>
                                <strong>E-mail:</strong>
                                <p><a :href="'mailto:' + warehouse.CUST_Email">{{warehouse.CUST_Email}}</a></p>
                            </li>
                        </ul>
                    </div>
                    <div v-if="$store.getters.user" class="card-footer bg-transparent">
                        <div class="text-center">
                        <b-button size="sm" variant="secondary" @click="setWarehouse(warehouse)">Producten</b-button>
                        </div>
                    </div>
                    </div>
                </b-col>
            </b-row>
        </div>
    </section>
</template>

<script>
import CategoryService from '@/services/CategoryService.js'
import WarehouseService from '@/services/WarehouseService.js'
import TranslationService from '@/services/TranslationService'
import CartService from '@/services/CartService.js'
import AuthorizationService from '@/services/AuthorizationService.js'
import LicenseService from '@/services/LicenseService.js'
import swal from 'sweetalert'

export default {
    data () {
        return {
            warehouses: {
                Collection: []
            },
            trioWarehousesCollection: [],
            localization: {},
            isUserLoggedIn: false
        }
    },
    methods: {
        async fetchWarehouses () {
            this.warehouses = await WarehouseService.getWarehouses()
            let i
            let amount = this.warehouses.Collection.length
            for (i = 0; i < amount;) {
                let j
                let warehousesRow = []
                for (j = 0; j < 3 && i < amount; j++) {
                    warehousesRow.push(this.warehouses.Collection[i])
                    i++
                }
                this.trioWarehousesCollection.push(warehousesRow)
            }
        },
        async getCategories () {
            let categories = await CategoryService.getCategories()
            this.$store.dispatch('setCategories', categories)
        },
        setWarehouse (warehouse) { // if we have items in cart, show a warning that cart will be emptied if user clicks OK
            if (this.$store.getters.cart.items && this.$store.getters.cart.items.length > 0) {
                this.showChangeWarehousePopup(warehouse)
            } else {
                WarehouseService.setWarehouse(warehouse)
                this.$router.push({ name: 'products' })
            }
        },
        showChangeWarehousePopup (warehouse) {
            let _this_ = this
            let popup = {
                text: TranslationService.get('CANNOT_CHANGE_WAREHOUSE'),
                icon: 'warning',
                dangerMode: true,
                buttons: true
            }
            swal(popup).then(async function (changeWarehouse) {
                if (changeWarehouse) {
                    await CartService.clearCart()
                    WarehouseService.setWarehouse(warehouse)
                    _this_.$router.push({ name: 'products' })
                }
            })
        }
    },
    created () {
        LicenseService.checkVersion()

        if (!this.$store.cart) {
            this.$store.dispatch('setCart', {items: []})
        }
        if (this.$store.getters.categories && this.$store.getters.categories.length <= 0) {
            this.getCategories()
        }
        this.fetchWarehouses()
        this.localization.warehouseID = this.$store.getters.warehouse.WarehouseID
        this.localization.address = this.$store.getters.warehouse.CUST_Address
        this.localization.openingHours = this.$store.getters.warehouse.CUST_OpeningHours
        this.localization.phoneNumber = this.$store.getters.warehouse.CUST_PhoneNumber
        this.localization.email = this.$store.getters.warehouse.CUST_Email
        this.isUserLoggedIn = AuthorizationService.isUserLoggedIn()
    }
}
</script>
<style>
  .card-warehouse {
    min-height: 400px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Homepage/Index.vue